const MAX_FREE_CREDITS = 3;
const FREE_USABLE_CREDITS = 3;

const commonConstants = {
  FREE_CREDITS: MAX_FREE_CREDITS,
  FREE_USABLE_CREDITS,
};

export default commonConstants;
